import { useTranslation } from "react-i18next";

export const getTranslationConstants = () => {
  const { t } = useTranslation();

  return {
    CHECKIN_SELECTTYPE: t("checkinTemplates.selectType"),
    CHECKIN_ASSIGNRATED: t("checkinTemplates.assignRated"),
    CHECKIN_ASSIGNRATERS: t("checkinTemplates.assignRaters"),
    CHECKIN_ASSIGNCOACHEE: t("checkinTemplates.assignCoachee"),
    CHECKIN_ASSIGNCOACH: t("checkinTemplates.assignCoach"),

    TARGET_LINKED: t("createVision.preview.linkedTargets"),
    TARGET_ATTACHMENT: t("targetDetails.attachment"),

    COMPANY_CONFIG_PERCENTAGE: t("companySetup.config.percentage.label"),
    COMPANY_CONFIG_GRADE: t("companySetup.config.grade.label"),

    TEXT_DETAIL: t("text.details"),
    TOAST_ERROR: t("toastMessages.errorMsg"),
    TOAST_CHECKIN_COMPLETE: t("toastMessages.checkin.markComplete")
  };
};
